export default __webpack_public_path__ + "static/media/Animations_Clock3.a4ccaaec.svg";